import React from 'react';
import ApiBidPack from '../../code/api/ApiBidPack';
import BidPackInfo from '../../code/models/BidPackInfo';
import AdminBidPackList from './AdminBidPackList';
import AdminBidPackLoadBidPacks from "./AdminBidPackLoadBidPacks";
import '../../css/adminbidpackagesimport.css';
import AdminBidPackImport from "./AdminBidPackImport";

interface IAdminBidPackagesImportForm { }

export default function AdminBidPackagesImportForm({ }: IAdminBidPackagesImportForm) {
    const [currentInfo, setCurrentInfo] = React.useState<BidPackInfo | null>(null);
    const [currentPage, setCurrentPage] = React.useState<string>("bidpacks");
    const pageImport: string = "import";
    const pageLoad: string = "load";
    const pageBidPacks: string = "bidpacks";

    React.useEffect(() => {
        loadHistory();
    }, []);

    var loading: boolean;

    function loadHistory() {
        if (loading) return;
        loading = true;

        ApiBidPack.getGetBidPackInfo().then(data => {
            if (!!data) {
                setCurrentInfo(data);
                var stat = (data.importRequest?.status || "").toLowerCase();
                if (!!stat && stat !== "complete" && stat !== "error" && stat !== "deleted") {
                    setTimeout(loadHistory, 5000);
                }
            }
        }).finally(() => { loading = false; });
    }

    function getTabClassName(tabInfo: string) {
        switch (currentPage + tabInfo) {
            case currentPage + currentPage: return "nav-link active";
            default: return "nav-link";
        }
    }

    return (
        <React.Fragment>
            <div className="bidpackimport-info">
                <div className="bidpack-div">
                    <span className="bidpack-title">Import Bid Packages</span>
                    {!!currentInfo && <span className="bidpack-label">Bid Period: {currentInfo?.bidPeriod.month}</span>}
                </div>
                <div className="bidpack-form">
                    <ul className="nav nav-pills">
                        <li className="nav-item">
                            <a className={getTabClassName(pageBidPacks)} href="#" onClick={() => setCurrentPage(pageBidPacks)}>Bid Packs</a>
                        </li>
                        <li className="nav-item">
                            <a className={getTabClassName(pageLoad)} href="#" onClick={() => setCurrentPage(pageLoad)}>Load Bid Packs</a>
                        </li>
                        <li className="nav-item">
                            <a className={getTabClassName(pageImport)} href="#" onClick={() => setCurrentPage(pageImport)}>Import Bid Packs</a>
                        </li>
                    </ul>
                </div>
            </div>
            {currentPage === pageBidPacks && <AdminBidPackList bidPacks={currentInfo?.bidPacks || []} />}
            {currentPage === pageLoad && !!currentInfo && <AdminBidPackLoadBidPacks bidPackInfo={currentInfo}
                onRefreshRequest={loadHistory} />}
            {currentPage === pageImport && !!currentInfo && <AdminBidPackImport bidPackInfo={currentInfo}
                onRefreshRequest={loadHistory} />}
        </React.Fragment >
    )
}

